<template>
  <div class="sign">
    <headers :title="title" :goBackHandler="goBack"></headers>
    <div class="content">
      <div class="info-box">
        <img class="avatar" :src="userInfo.avatar" />
        <div class="info">
          <p class="name">{{ userInfo.nickname }}</p>
          <p class="integral">{{point_name}}：{{ signInfo.total_integral }}</p>
        </div>
        <p class="btn-rule" @click="onShowSignRule">签到规则</p>
      </div>
      <div class="calendar-box">
        <sign-calendar
          :sign-dates="signedDates"
          :task-switch-init="signInfo.sign_notice == 1"
          @onCurDate="onCurDate"
          @onChangeDate="onChangeDate"
        ></sign-calendar>
      </div>
      <div class="recommend-wrap" v-if="recommendCourses.length">
        <div class="head">
          <p class="title">好课推荐</p>
          <p class="more" @click="onMore(1)">更多</p>
        </div>
        <div>
          <IntegralItem v-for="(item, index) in recommendCourses" :key="index" :item="item"></IntegralItem>
        </div>
      </div>
      <div class="recommend-wrap" v-if="recommendBooks.length">
        <div class="head">
          <p class="title">热门图书</p>
          <p class="more" @click="onMore(2)">更多</p>
        </div>
        <div>
          <IntegralItem v-for="(item, index) in recommendBooks" :key="index" :item="item"></IntegralItem>
        </div>
      </div>
    </div>
    <van-popup v-model="popupSigned.show" :close-on-click-overlay="false">
      <div class="signed-box">
        <img class="bg" src="@/assets/images/sign/bg-signed.png" />
        <p class="note">恭喜获得{{ popupSigned.point }}{{point_name}}</p>
        <img
          class="btn-close"
          src="@/assets/images/sign/icon-close.png"
          @click="popupSigned.show = false"
        />
      </div>
    </van-popup>
    <van-dialog v-model="showSignRule" title="签到规则" confirm-button-text="我知道了">
      <div v-html="signRuleInfo"></div>
    </van-dialog>
  </div>
</template>

<script>
import headers from "@/components/Header.vue";
import SignCalendar from "./SignCalendar";
import IntegralItem from "@/components/integral/IntegralItem";
export default {
  name: "sign",
  components: {
    SignCalendar,
    IntegralItem,
    headers
  },
  data() {
    return {
      title: {
        name: "签到领积分"
      },
      userInfo: {},
      signInfo: {},
      signedDates: [],
      popupSigned: {
        show: false,
        point: 0
      },
      showSignRule: false,
      recommendCourses: [],
      recommendBooks: []
    };
  },
  computed: {
    signRuleInfo() {
      if (this.signInfo.sign_rules) {
        return this.signInfo.sign_rules.point_sign_rule_info;
      }
      return "";
    },
    point_name() {
      if(this.$store.state.config){
        return this.$store.state.config.point_info.point_name
      } else{
        return '';
      };
    }
  },
  created() {
    this.requestUserInfo();
    this.requestSignInfo();
    this.requestRecommend();
  },
  methods: {
    goBack () {
      if (this.$store.state.app) {
        this.$pub.appAction("closeAppPage");
      } else{
        this.$router.go(-1);
      }
    },
    // on event
    onCurDate(date) {
      this.$http
        .get("/api/app/user/integral/signRecord", { date })
        .then(data => {
          this.signedDates.push(...data);
        });
    },
    onChangeDate(date) {
      this.$http
        .get("/api/app/user/integral/signRecord", { date })
        .then(data => {
          this.signedDates = data;
        });
    },
    onShowSignRule() {
      this.showSignRule = true;
    },
    onMore(tab) {
      this.$router.push({
        name: "IntegralStore",
        query: {
          tab
        }
      });
    },
    // other
    // request
    requestUserInfo() {
      this.$http.get("/api/app/userInfo").then(data => {
        this.userInfo = data;
      });
    },
    requestSignInfo() {
      this.$http.get("/api/app/user/integral/isSign").then(data => {
        this.signInfo = data;
        // 设置title
        document.title = this.signInfo.sign_rules.page_title;
        // 是否签到 1:已签到 2:未签到
        if (this.signInfo.is_sign == 2) {
          this.$http.post("/api/app/user/integral/sign").then(data => {
            this.signedDates.push(data);
            this.popupSigned.show = true;
            this.popupSigned.point = data.point;
          });
        }
      });
    },
    requestRecommend() {
      // 获取推荐，最多显示3个
      // recommend course
      this.$http
        .get("/api/integral/shop/index", {
          type: 1
        })
        .then(data => {
          this.recommendCourses = data.list.slice(0, 3);
        });
      // recommend book
      this.$http
        .get("/api/integral/shop/index", {
          type: 2
        })
        .then(data => {
          this.recommendBooks = data.list.slice(0, 3);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.sign {
  position: relative;
  @extend %default-bg;
  background-color: #fff;
  &::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 560px;
    background: url("~@/assets/images/sign/bg.png") center no-repeat;
    background-size: cover;
  }
  .content {
    position: relative;
    z-index: 1;
    .info-box {
      padding: 60px 0;
      margin: 0 40px;
      color: #fff;
      display: flex;
      align-items: center;
      position: relative;
      .avatar {
        width: 88px;
        height: 88px;
        border-radius: 50%;
        flex: none;
        margin-right: 16px;
      }
      .info {
        .name {
          font-size: 36px;
          font-weight: 500;
          margin-bottom: 12px;
          width: 400px;
          word-wrap: break-word;
        }
        .integral {
          font-size: 24px;
          font-weight: 500;
        }
      }
      .btn-rule {
        position: absolute;
        right: 0px;
        font-size: 24px;
        padding: 0 26px;
        border: 2px solid #fff;
        border-radius: 25px;
        height: 40px;
        line-height: 40px;
      }
    }
    .calendar-box {
      width: 674px;
      // height: 700px;
      background: #fff;
      box-shadow: 0px 16px 24px 0px rgba(0, 0, 0, 0.1);
      border-radius: 25px;
      margin: 0 38px;
      box-sizing: border-box;
      overflow: hidden;
      margin-bottom: 50px;
      .sign-calendar {
        border-radius: 25px;
      }
    }
    .recommend-wrap {
      padding: 0 30px;
      margin-bottom: 50px;
      .head {
        display: flex;
        justify-content: space-between;
        margin-bottom: 40px;
        .title {
          font-size: 32px;
          color: #595959;
          font-weight: 500;
          position: relative;
          padding-left: 20px;
          &::after {
            content: "";
            display: inline-block;
            width: 4px;
            height: 26px;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            background-color: $theme_color;
          }
        }
        .more {
          font-size: 28px;
          color: #b7b7b7;
          position: relative;
          padding-right: 20px;
          line-height: 32px;
          &::after {
            content: "";
            display: block;
            border-top: 2px solid #b7b7b7;
            border-right: 2px solid #b7b7b7;
            width: 14px;
            height: 14px;
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%) rotate(45deg);
          }
        }
      }
    }
  }
  .van-popup {
    background-color: transparent;
  }
  .signed-box {
    position: relative;
    .bg {
      width: 384px;
    }
    .note {
      color: #fff;
      font-size: 26px;
      font-weight: 500;
      position: absolute;
      left: 50%;
      top: 290px;
      transform: translateX(-50%);
      white-space: nowrap;
    }
    .btn-close {
      width: 40px;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  /deep/ .van-dialog {
    .van-dialog__content {
      padding: 0 40px 40px 40px;
      color: #8c8c8c;
      font-size: 26px;
      line-height: 36px;
    }
    .van-button {
      background-color: #fff;
      color: #595959;
      font-size: 28px;
    }
  }
}
</style>
